import React from "react";


const ConfirmationModal = ({ message, onConfirm, onCancel }) => {
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.message}>
          <p>{message}</p>
        </div>
        <div style={styles.buttons}>
          <button style={styles.buttonYes} onClick={onConfirm}>Yes</button>
          <button style={styles.buttonNo} onClick={onCancel}>No</button>
        </div>
      </div>
    </div>
  );
};

// Styles
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "300px",
    textAlign: "center",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  },
  message: {
    marginBottom: "20px",
    fontSize: "16px",
    color: "#333",
  },
  buttons: {
    display: "flex",
    justifyContent: "space-around",
  },
  buttonYes: {
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  buttonNo: {
    padding: "10px 20px",
    backgroundColor: "#f44336",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default ConfirmationModal;
